export const CURRENT_SCHEMA_VERSION = 1;

export type SkillLevel = 'beginner' | 'intermediate' | 'advanced' | 'expert';
export type LanguageLevel = 'A1' | 'A2' | 'B1' | 'B2' | 'C1' | 'C2' | 'native';
export type CvLanguage = 'pl' | 'en' | 'de';
export type ModernSidebarStyle = 'dots' | 'bars' | 'chips';

export interface CvAddress {
  city?: string;
  country?: string;
}

export interface CvWebsite {
  id: string;
  label: string;
  url: string;
  displayText?: string;
}

export interface CvPersonalInfo {
  firstName: string;
  lastName: string;
  title?: string;
  email: string;
  phone?: string;
  address?: CvAddress;
  photoId?: string;
  summary?: string;
  websites?: CvWebsite[];
}

export interface CvExperience {
  id: string;
  company: string;
  position: string;
  startDate: string;
  endDate?: string;
  location?: string;
  description?: string;
  achievements?: string[];
}

export interface CvEducation {
  id: string;
  institution: string;
  degree: string;
  field?: string;
  startDate: string;
  endDate?: string;
  description?: string;
}

export interface CvSkill {
  id: string;
  name: string;
  level?: SkillLevel;
  category?: string;
}

export interface CvLanguageEntry {
  id: string;
  name: string;
  level: LanguageLevel;
}

export interface CvProject {
  id: string;
  name: string;
  description?: string;
  technologies?: string[];
  url?: string;
  startDate?: string;
  endDate?: string;
}

export interface CvCertification {
  id: string;
  name: string;
  issuer: string;
  date: string;
  url?: string;
}

export interface CvCustomSection {
  id: string;
  title: string;
  content: string;
  order: number;
}

export type CvSectionKey =
  | 'experience'
  | 'education'
  | 'skills'
  | 'languages'
  | 'projects'
  | 'certifications'
  | 'customSections';

export interface CvSectionVisibility {
  key: CvSectionKey;
  visible: boolean;
  order: number;
}

export interface CvSettings {
  selectedTemplate: string;
  color?: string;
  font?: string;
  language: CvLanguage;
  sectionOrder?: CvSectionVisibility[];
  modernSidebarStyle?: ModernSidebarStyle;
}

export interface CvMetadata {
  createdAt: string;
  updatedAt: string;
  schemaVersion: number;
  name?: string;
}

export interface CvData {
  id: string;
  metadata: CvMetadata;
  personalInfo: CvPersonalInfo;
  experience: CvExperience[];
  education: CvEducation[];
  skills: CvSkill[];
  languages: CvLanguageEntry[];
  projects?: CvProject[];
  certifications?: CvCertification[];
  customSections?: CvCustomSection[];
  settings: CvSettings;
}

export interface PhotoBlob {
  id: string;
  blob: Blob;
  mimeType: string;
  createdAt: string;
}
